














import axios from "axios";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class CountryCombo extends Vue {
  @Prop({ type: Array, default: () => [] }) value!: string[];

  private loading: boolean = false;
  private items: object[] = [];

  // hooks
  // -------------------------------------------------------------------
  async created() {
    this.loading = true;
    let response = await axios.get("/psql/geo_entities", {
      params: {
        select: "iso3,idmc_short_name",
        order: "idmc_short_name",
      },
    });
    this.items = response.data;
    this.loading = false;
  }

  // methods
  // -------------------------------------------------------------------

  updateValue(value: string[]) {
    this.$emit("input", value);
  }
}
